import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
export class ChartRange {
    /**
     * Takes a serie object and an idChart string or HTMLElement as parameters,
     * and then it sets the type, options, data, and originalData properties.
     * The data variable calls the parent and prepare the data
     * @param {IChartSeries} serie - IChartSeries
     * @param {IAmchartBase} chart - Chart Object
     */
    constructor(serie, chart) {
        /**
        * Elements of the serie.
        */
        this.seriesElement = [];
        const { title, xAxeId, yAxeId, type, options, data, } = serie;
        this.title = title;
        this.xAxeId = xAxeId;
        this.yAxeId = yAxeId;
        this.chart = chart;
        this.type = type;
        this.options = options;
        this.data = chart.prepareSeriesData(data);
        // Validate that the category type matches before proceeding
        if (!chart.validateTypeChart(this.type))
            throw new Error('Combination of TypeChart is not valid.');
        // No hay validacion de los tipos de datos No funcionaba bien con todos los casos
        // Si la vemos necesaria hay que darle una vuelta al codigo
        // Nota si no coinciden los tipos de datos que se ponen en las categorias
        // es que ha hecho algo mal en el vertical
        // Initialize the chart axis
        this.setAxis();
    }
    /**
     * The function creates a series, then shows bullets.
     */
    initSerie(enableZoom) {
        this.enableZoom = enableZoom;
        this.createSeries();
        this.showBullets();
        this.chart.setSerie(this);
    }
    /**
     * It checks if the bullets option is enabled,
     * if it is generates bullets for the chart
     */
    showBullets() {
        // Get the 'bullets' property from the options object
        const { bullets } = this.options;
        // If the 'bullets' property is falsy, return and exit the function
        if (!bullets)
            return;
        // Add a new bullet to the series element using the 'generateBullet' method from the base class
        this.seriesElement.forEach((serie) => {
            serie.bullets.push(() => this.chart.generateBullet(bullets));
        });
    }
    /**
     * This function sets the xAxisElement and yAxisElement properties of the class to the xAxis and
     * yAxis properties of the chart.
     */
    setAxis() {
        const { xAxis, yAxis } = this.chart;
        this.xAxisElement = xAxis;
        this.yAxisElement = yAxis;
    }
    /**
     * Create the series of chartLine
     */
    createSeries() {
        var _a, _b, _c;
        // Destructuring the colors from options
        const { fillColor, strokeColor } = this.getColors();
        const xAxisSerieResult = this.chart.chart
            .xAxes.values.filter((item) => item.name === this.xAxeId);
        const yAxisSerieResult = this.chart.chart
            .yAxes.values.filter((item) => item.name === this.yAxeId);
        let axisX = this.xAxisElement;
        if (xAxisSerieResult && xAxisSerieResult.length > 0) {
            axisX = xAxisSerieResult[0];
            if (xAxisSerieResult[0].complementaryAxis) {
                this.complementaryAxis = xAxisSerieResult[0].complementaryAxis;
            }
        }
        let axisY = this.yAxisElement;
        if (yAxisSerieResult && yAxisSerieResult.length > 0) {
            axisY = yAxisSerieResult[0];
        }
        // Creating a new lower range line series and pushing it into the chart
        const seriesLower = this.chart.chart.series.push(am5xy.LineSeries.new(this.chart.root, {
            name: this.title,
            xAxis: axisX,
            yAxis: axisY,
            valueYField: 'valueLowerRange',
            valueXField: 'category',
            sequencedInterpolation: false,
            categoryXField: 'category',
            stroke: am5.color(strokeColor),
            fill: am5.color(fillColor),
            locationX: 0.5,
            maskBullets: false,
            connect: false,
            autoGapCount: 60000000, // Harcoded for gaps. Claculated for 50 years with 5 minute data. https://github.com/amcharts/amcharts5/issues/1473
        }));
        this.hiddenSerie = seriesLower;
        // Creating a new upper range line series and pushing it into the chart
        const seriesUpper = this.chart.chart.series.push(am5xy.LineSeries.new(this.chart.root, {
            name: this.title,
            xAxis: axisX,
            yAxis: axisY,
            valueYField: 'valueUpperRange',
            openValueYField: 'valueLowerRange',
            valueXField: 'category',
            sequencedInterpolation: false,
            categoryXField: 'category',
            stroke: am5.color(strokeColor),
            fill: am5.color(fillColor),
            locationX: 0.5,
            maskBullets: false,
            connect: false,
            autoGapCount: 60000000,
            userData: { relatedSerie: seriesLower }, // Harcoded for gaps. Claculated for 50 years with 5 minute data. https://github.com/amcharts/amcharts5/issues/1473
        }));
        seriesUpper.on('visible', (visible) => {
            if (this.chart.chart) {
                if (visible) {
                    seriesUpper.show();
                    seriesLower.show();
                }
                else {
                    seriesUpper.hide();
                    seriesLower.hide();
                }
            }
        });
        // Set opacity in upper serie fill
        seriesUpper.fills.template.setAll({
            fillOpacity: 0.3,
            visible: true,
        });
        // If showCursor not informed initialize to true by default;
        this.options.showCursor = (_a = this.options.showCursor) !== null && _a !== void 0 ? _a : true;
        if (this.options.showCursor) {
            const cursorOptions = {};
            if (this.enableZoom) {
                cursorOptions.behavior = 'zoomX';
            }
            if (this.options.enableTooltip) {
                const allSeries = this.chart.chart.series.values;
                const tooltip = this.chart.generateTooltip(this.options.tooltipFormat, this.yAxeId);
                seriesLower.set('tooltip', tooltip);
                seriesUpper.set('tooltip', tooltip);
                cursorOptions.snapToSeries = allSeries;
            }
            const cursor = this.chart.chart.set('cursor', am5xy.XYCursor.new(this.chart.root, cursorOptions));
            cursor.lineY.set('visible', false);
        }
        seriesLower.strokes.template.setAll({
            strokeWidth: (_b = this.options.strokeWidth) !== null && _b !== void 0 ? _b : 2,
            strokeDasharray: this.options.strokeDasharray ? this.options.strokeDasharray : null,
        });
        seriesUpper.strokes.template.setAll({
            strokeWidth: (_c = this.options.strokeWidth) !== null && _c !== void 0 ? _c : 2,
            strokeDasharray: this.options.strokeDasharray ? this.options.strokeDasharray : null,
        });
        if (this.chart.enableSerieAnimation) {
            seriesLower.strokes.template.events.on('pointerover', () => {
                this.chart.pointerOverEvent(this.chart.chart.series, seriesLower);
            });
            seriesLower.strokes.template.events.on('pointerout', () => {
                this.chart.pointerOutEvent(this.chart.chart.series);
            });
            seriesUpper.strokes.template.events.on('pointerover', () => {
                this.chart.pointerOverEvent(this.chart.chart.series, seriesLower);
            });
            seriesUpper.strokes.template.events.on('pointerout', () => {
                this.chart.pointerOutEvent(this.chart.chart.series);
            });
        }
        // Setting the x-axis data
        this.xAxisElement.data.setAll(this.data);
        // Setting the series data
        seriesLower.data.setAll(this.data);
        seriesUpper.data.setAll(this.data);
        if (this.complementaryAxis) {
            this.complementaryAxis.data.setAll(this.data);
        }
        // Animating the series appearance
        seriesLower.appear(1000);
        seriesUpper.appear(1000);
        // Animating the chart appearance
        this.chart.chart.appear(1000, 100);
        // Saving the series element for later use
        this.seriesElement = [seriesLower, seriesUpper];
    }
    /**
     * If the `fillColor` and `strokeColor` options are not defined,
     * then use the default values.
     */
    getColors() {
        const { fillColor, strokeColor } = this.options;
        const defaultStrokeColor = '#d1f2f5';
        const defaultFillColor = '#c5c2c2';
        return {
            fillColor: fillColor !== null && fillColor !== void 0 ? fillColor : defaultFillColor,
            strokeColor: strokeColor !== null && strokeColor !== void 0 ? strokeColor : defaultStrokeColor,
        };
    }
}
//# sourceMappingURL=chartRange.js.map